import store from '../../store'
import axios from 'axios'

const BlizLoginUrl = {
  // '10': 'https://biz.ipickup.com.tw/SSO?UserName=ZhTech_bk&ReturnUrl_Token=',
  // '20':
  //   'https://www.bizlion.com.tw/BizLion/SignIn/Login?username=ZhTech&userToken_returnUrl='
    '10': '/SSO?UserName=ZhTech_bk&ReturnUrl_Token=',
    '20': '/BizLion/SignIn/Login?username=ZhTech&userToken_returnUrl='
}
function initDetailLogic() {
  // 是否需要商業獅登入，且網址列沒有拿到 Token
  // P.S. 可填寫人員種類(商業獅會員(20)、商業師管理人員(10))
  let userToken = store.state.userToken
  let clientUserType = store.state.questM.clientUserType
  // 是否需要導向商業獅 SSO 登入
  let needBlizLogin =
    ['10', '20'].includes(clientUserType) && (!userToken || userToken.length === 0)
  if (needBlizLogin) {
    // 4.導向商業獅 SSO 登入頁面
    if(clientUserType == "10")
      BlizLoginUrl[clientUserType] = store.state.loginServerEnterprise + BlizLoginUrl[clientUserType]
      else
      BlizLoginUrl[clientUserType] = store.state.loginServer + BlizLoginUrl[clientUserType]
    window.location.href = BlizLoginUrl[clientUserType] + window.location.href
  } else {
    // 如果不需要商業獅 SSO 登入(已有userToken、clientUserType)
    // 判斷是否為商業獅一般會員 (20)
    // 取得商業獅一般會員手機的額外邏輯：
    if (clientUserType === '20') {
      //  如果有指定檢核為手機的題目
      if (store.state.questD.findIndex(x => x.isAssign && x.inputCheck === '30') != -1) {
        // 取得手機號碼
        getPhoneNum()
      }
    }
  }
}

export default { initDetailLogic }
async function getPhoneNum() {
  let url = store.state.api + '/User/getPhoneNum'
  // let url = store.state.api + '/user/api/User/getPhoneNum'
  let res = await axios.get(url, { params: { userToken: store.state.userToken } })
  switch (res.data.resultCode) {
    case '10': // 取得成功
      store.commit('setPhoneNum', res.data.PhoneNum)
      break
    case '01': // 取得失敗
      throw new Error(res.data.error)
    default:
      throw new Error('嘗試取得手機號碼時，API 未回傳已知的狀態代碼')
  }
}
